import Vue from 'vue'
// 表单验证插件
import VeeValidate, {Validator} from 'vee-validate'
// 表单验证插件中文包
import zh from 'vee-validate/dist/locale/zh_CN'
// 添加中文包
Validator.addLocale(zh)
// 配置中文
const config = {
  locale: 'zh_CN'
}
// 注册表单插件
Vue.use(VeeValidate, config)

// 自定义验证规则
Validator.extend('phone', {
  messages: {
    zh_CN: field => field + '必须是11位手机号码'
  },
  validate: value => {
    return value.length === 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/.test(value)
  }
})

// 修改默认提示信息
const dictionary = {
  zh_CN: {
    messages: {
      // 修改邮箱格式错误时的提示信息
      email: () => 'email格式错误',
      // 修改默认 required 的文字提示信息
      required: (field) => field
    },
    // 修改字段提示的名称
    attributes: {
      email: '请输入email',
      heroUser: '请输入英雄账号',
      phone: '请输入手机',
      user: '请输入姓名',
      pwd: '是否设置密码',
      password: '请输入密码',
      serverName: '请输入服务器名称',
      serverType: '请选择房间类型',
      rootList: '请选择是否公开房间列表',
      serverPackage: '请选择服务器套餐',
      mapName: '请输入地图名称',
      gameDesc: '请输入游戏介绍'
    }
  }
}
// 更新配置
Validator.updateDictionary(dictionary)



// WEBPACK FOOTER //
// ./src/lib/VeeValidate/index.js